module.exports = __webpack_public_path__ + "media/images/app-store-8379410833ad50610bcae3bc2fe0e0c1.png";